// Entry for the Billing page island. Auth-gates (/api/auth/me; 401 → /login),
// then mounts the container with the loaded user. Same shape as My Profile.
import React from 'react';
import { createRoot } from 'react-dom/client';
import '../shared/fonts.css';
import '../shared/theme.css';
import '../shared/base.css';
import './billing.css';
import BillingContainer from './BillingContainer.jsx';
import { sendToVerifyMobile } from '../shared/phoneGate.js';
import { signedOutUrl } from './gate.js';

async function boot() {
  const root = createRoot(document.getElementById('root'));
  let user = null;
  try {
    const r = await fetch('/api/auth/me', { credentials: 'include' });
    if (r.status === 401) { window.location.replace(signedOutUrl()); return; }
    if (r.ok) user = (await r.json()).user;
  } catch (_) { /* render with nulls; status fetch re-gates on 401 */ }
  if (sendToVerifyMobile(user)) return;
  root.render(<BillingContainer user={user} />);
}

boot();
